import { KintellCard, User, Booking } from '@/models'
import KintellCardSpec from '@/lib/models/KintellCardSpec'
import BookingSpec from '@/lib/models/BookingSpec'
import UserSpec from '@/lib/models/UserSpec'

export interface ModelResolver {
  resolve(): void,
}

export abstract class Message {
  public constructor (public data: Record<string, any>) {
    Object.assign(this, { ...data })
    return this
  }
}

export abstract class ModelMessage extends Message {
  abstract resolve(): Promise<void>
}

export class UserMessage extends ModelMessage {
  user: UserSpec

  async resolve () {
    this.user = await (new User().find(this.user.id))
  }
}

export interface ModelMessageConstructable {
  new(data: any): Message | ModelMessage,
}

export class KintellCardMessage extends ModelMessage {
  kintellCard: KintellCardSpec

  async resolve () {
    this.kintellCard = await (new KintellCard().find(this.kintellCard.id))
  }
}

export class BookingMessage extends ModelMessage {
  booking: BookingSpec

  async resolve () {
    this.booking = await (new Booking().find(this.booking.id))
  }
}

export class UpdateMessage extends Message {
  version: string
}

